export const EVAC_MANUFACTURER_REG = "evacManufacturer"
export const EVAC_MODEL_REG = "evacModel"
export const EVAC_MODEL_REF_REG = "evacModelRef"
export const EVAC_BARCODE_REG = "evacBarcode"
export const EVAC_PHASES_REG = "evacPhases"
export const EVAC_VOLTAGE_REG = "evacVoltage"
export const EVAC_MAX_CURRENT_REG = "evacMaxCurrent"
export const EVAC_AC_ONLY_REG = "evacAcOnly"
export const EVAC_V2G_CAPABILITY_REG = "evacV2gCapability"
export const EVAC_V2G_EXPORT_CAPACITY_REG = "evacV2gExportCapacity"
export const EVAC_V2G_COMPLETION_DATE_REG = "evacV2gCompletionDate"
export const EVAC_V2G_G99_REG = "evacV2gG99gbG999niBoth"
export const EVAC_V2G_TTR_STATUS_REG = "evacV2gTtrStatus"
export const EVAC_ADDITIONAL_COMMENTS_REG = "evacAdditionalComments"

export const evacDeviceFormLabelMapping: { [key: string]: string } = {
    [EVAC_MANUFACTURER_REG]: "Manufacturer",
    [EVAC_MODEL_REG]: "Model",
    [EVAC_MODEL_REF_REG]: "Model Reference Number",
    [EVAC_BARCODE_REG]: "Barcode Number",
    [EVAC_PHASES_REG]: "Phases",
    [EVAC_VOLTAGE_REG]: "Voltage (V)",
    [EVAC_MAX_CURRENT_REG]: "Max Current Amps per Phase",
    [EVAC_AC_ONLY_REG]: "Do the charger have only AC output?",
    [EVAC_V2G_CAPABILITY_REG]: "Does the charger have V2G Capability?",
    [EVAC_V2G_EXPORT_CAPACITY_REG]: "V2G Export Capacity",
    [EVAC_V2G_COMPLETION_DATE_REG]: "V2G Completion Date",
    [EVAC_V2G_G99_REG]: "V2G G99/GB, G99/NI, Both",
    [EVAC_V2G_TTR_STATUS_REG]:
        "V2G Inverter System Reference in ENA Generation Asset Register",
    [EVAC_ADDITIONAL_COMMENTS_REG]: "Additional Comments",
}

export const NON_SYS_ADMIN_EVAC_STEPS = [
    "Core EVAC Device Details",
    "Supporting Files",
    "Review and Submit",
]

export const NON_SYS_ADMIN_EVAC_STEPS_AMEND = [
    "Amend Core EVAC Device Details",
    "Amend Supporting Files",
    "Review and Submit Amendment",
]
export const SYS_ADMIN_LCT_STEPS = ["Manufacturer"]

// TODO: TaiOla - Use real data
export const v2gG99Options: { [key: number]: string } = {
    1: "G99/GB",
    2: "G99/NI",
    3: "Both",
}
